<template>
  <v-main
    :style="{
      background: $vuetify.theme.dark
        ? $vuetify.theme.themes.dark.background
        : $vuetify.theme.themes.light.background,
    }"
  >

    <v-slide-y-transition mode="out-in"> 
      <router-view />
    </v-slide-y-transition>
    <vue-internet-checker
      @wifi_status="wifi_status"
      @mqtt_connection="mqtt_status"
    />
    <v-snackbar
      v-model="snackbar.show"
      :vertical="snackbar.vertical"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      multi-line
      left
      top
    >
      <v-icon v-if="onLine">mdi-wifi</v-icon
      ><v-icon v-else>mdi-wifi-off</v-icon> {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="snackbarMqtt.show"
      :vertical="snackbarMqtt.vertical"
      :color="snackbarMqtt.color"
      :timeout="snackbarMqtt.timeout"
      multi-line
      left
    >
      <v-icon v-if="onLine">mdi-wifi</v-icon
      ><v-icon v-else>mdi-wifi-off</v-icon> {{ snackbarMqtt.text }}

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbarMqtt.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
export default {
  name: "DashboardCoreView",
  data: () => ({
    onLine: navigator.onLine,
    snackbar: {
      show: false,
      text: "",
      color: "success",
      vertical: false,
      timeout: 5000,
    },
    snackbarMqtt: {
      show: false,
      text: "",
      color: "success",
      vertical: false,
      timeout: 5000,
    },
    mqttStatus: false,
  }),
  created() {
    if (!this.onLine) {
      console.log("Offline");
      this.snackbar.text = "คุณออฟไลน์อยู่";
      this.snackbar.color = "red";
      this.snackbar.timeout = -1;
      this.snackbar.show = true;
    }
  },
  methods: {
    mqtt_status(e) {
      if (this.mqttStatus !== e) {
        this.mqttStatus = e;
        console.log("MQTT Status: ", this.mqttStatus);
        if (!this.mqttStatus) {
          this.snackbarMqtt.text = "ขาดการเชื่อมต่อกับเครื่องแม่ข่าย";
          this.snackbarMqtt.color = "red";
          this.snackbarMqtt.timeout = -1;
          this.snackbarMqtt.show = true;
        } else {
          if (this.snackbarMqtt.show) {
            this.snackbarMqtt.show = false;
            setTimeout(() => {
              this.snackbarMqtt.text =
                "การเชื่อมต่อกับเครื่องแม่ข่ายของคุณกลับมาแล้ว";
              this.snackbarMqtt.color = "green";
              this.snackbarMqtt.timeout = 5000;
              this.snackbarMqtt.show = true;
            }, 1000);
          }
        }
      }
    },
    wifi_status(e) {
      console.log("App::wifi_status");

      if (this.onLine !== e) {
        if (e === true && this.onLine === false) {
          console.log("Online");
          if (this.snackbar.show === true) {
            this.snackbar.show = false;
            setTimeout(() => {
              this.snackbar.text = "การเชื่อมต่ออินเตอร์เน็ตของคุณกลับมาแล้ว";
              this.snackbar.color = "green";
              this.snackbar.timeout = 5000;
              this.snackbar.show = true;
            }, 1000);
          }
        }
      }
      if (!this.onLine) {
        console.log("Offline");
        this.snackbar.text = "คุณออฟไลน์อยู่";
        this.snackbar.color = "red";
        this.snackbar.timeout = -1;
        this.snackbar.show = true;
      }
      this.onLine = e;
    },
  },
};
</script>
